export const overtimeMultiplierItems = [0, 1, 1.5];

export const defaultApproveExtraData = {
  is_billable: false,
  is_overtime_payable: false,
  overtime_multiplier: 0,
  assignment_id: null,
};
